import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import { ApiResponse } from "./types";
import { post } from "./api";

export type ReconciliationReportFields = {
  id: string;
  message: string;
};

export default function useReportReconciliation(
  workspaceId: string,
  id?: string
): UseMutationResult<ApiResponse<any>, unknown, ReconciliationReportFields, unknown> {
  const queryClient = useQueryClient();

  return useMutation((values) => reportReconciliation(values as ReconciliationReportFields), {
    onSettled: (data, error, values: ReconciliationReportFields) => {
      queryClient.invalidateQueries(["reconciliation", values.id]);
      queryClient.invalidateQueries(["reconciliations", workspaceId]);
    },
  });
}

async function reportReconciliation({ id, ...values }: ReconciliationReportFields): Promise<ApiResponse<any>> {
  const endpoint = `reconciliation/${id}/report`;
  const response = await post(endpoint, values, true, "Report submitted");

  if (!response.ok) throw response.error;

  return {
    ok: true,
    error: "",
    data: response.data,
  };
}
